export const STOCK_FEATURES_SET = 'STOCK_FEATURES_SET'
export const STOCK_FEATURES_FETCHING = 'STOCK_FEATURES_FETCHING'
export const STOCK_FEATURES_ADD = 'STOCK_FEATURES_ADD'
export const STOCK_FEATURES_ADDING = 'STOCK_FEATURES_ADDING'
